import classnames from 'classnames/bind'
import { Tooltip } from 'react-tooltip'

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

export enum Place {
  TOP = 'top',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  RIGHT = 'right',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  LEFT = 'left',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
}

// PropTypes
type PropTypes = {
  id: string
  children: any
  className?: string
  place: Place
  isOpen?: boolean
  offset?: number
}

function TooltipComponent(props: PropTypes) {
  const { id, children, className, place = 'top', isOpen, offset = 0 } = props

  return (
    <Tooltip
      className={cx('tooltip', className)}
      classNameArrow={cx('tooltip-arrow', place)}
      anchorSelect={`#${id}`}
      place={place}
      isOpen={isOpen}
      opacity={1}
      offset={offset}
    >
      {children}
    </Tooltip>
  )
}

export default TooltipComponent
